import type { InjectionKey } from "vue";

import type { GlobalStore } from './global.store';
import type { OnboardingStatusStore } from "./onboarding.store";
import type { BankAccountsStore } from "./bank-accounts.store";
import type { BusinessPhoneVerificationStore } from "@/store/business-phone-verification.store";

export const GLOBAL_STORE_INJECTION_KEY = Symbol() as InjectionKey<GlobalStore>;
export const ONBOARDING_STATUS_STORE_INJECTION_KEY = Symbol() as InjectionKey<OnboardingStatusStore>;
export const BANK_ACCOUNTS_STORE_INJECTION_KEY = Symbol() as InjectionKey<BankAccountsStore>;
export const BUSINESS_PHONE_VERIFICATION_STORE_INJECTION_KEY = Symbol() as InjectionKey<BusinessPhoneVerificationStore>;
